var _circle, _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncementUserLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#7F3DFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_4443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 28.077C20.5591 28.077 17.7696 25.2876 17.7696 21.8466C17.7696 18.4057 20.5591 15.6162 24.0001 15.6162C27.441 15.6162 30.2305 18.4057 30.2305 21.8466C30.2305 25.2876 27.441 28.077 24.0001 28.077Z",
    stroke: "#212121",
    strokeWidth: 1.50926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 34.2099C33.0614 32.3645 31.6304 30.8148 29.8655 29.7324C28.1005 28.65 26.0705 28.077 24.0001 28.077C21.9297 28.077 19.8996 28.6499 18.1347 29.7324C16.3697 30.8148 14.9387 32.3645 14.0001 34.2099",
    stroke: "#212121",
    strokeWidth: 1.50926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_4443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 34 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementUserLogo);
export default __webpack_public_path__ + "static/media/AnnouncementUserLogo.3ab5ccde.svg";
export { ForwardRef as ReactComponent };